import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { logout, setAccess } from "../../../store/authSlice";
import { denyAccess } from "../../../api/access";
import { useTranslation } from "react-i18next";
import ProfileDropdown from "../../../components/ProfileDropdown";
import { useViewport } from "../../../hooks/useViewport";

export default function Navbar() {
  const { t } = useTranslation();
  const names = useAppSelector((state) => state.auth.names);
  const username = useAppSelector((state) => state.auth.username);
  // Четем дали потребителят има потвърден достъп — ако да, UnrealSoft е amber
  const access = useAppSelector((state) => state.auth.access);
  const { isNarrow } = useViewport();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    if (access) {
      // Ако има потвърден достъп — премахваме го вместо да излизаме
      try {
        await denyAccess();
      } catch (error) {
        console.error("Deny access error:", error);
      }
      dispatch(setAccess(false));
      navigate("/", { replace: true });
    } else {
      // Нормален logout
      await dispatch(logout());
      navigate("/login", { replace: true });
    }
  };

  return (
    <header
      className="flex items-center justify-between bg-surface/95 backdrop-blur-sm shadow-md px-4 h-16"
      style={{
        background: access
          ? "radial-gradient(ellipse 40% 120% at 100% 50%, var(--color-brand-tint) 0%, transparent 70%), color-mix(in srgb, var(--color-surface) 95%, transparent)"
          : undefined,
      }}
    >
      <div className="flex items-center gap-3">
        <div
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img
            src="/logo-ts.png"
            alt="UnrealSoft"
            className="h-10 w-8 rounded-md object-contain"
          />
          <div className="xs:block">
            {/* На телефон „UnrealSoft" се крие — остава логото + подзаглавието. */}
            {!isNarrow && (
              <div
                className={`font-semibold ${access ? "text-amber-500" : ""}`}
              >
                {t("common.appName")}
              </div>
            )}
            <div className="text-xs text-gray-500">
              {t("navbar.discountsSubtitle")}
              {(names || username) && ` | ${names || username}`}
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <ProfileDropdown
          displayName={names || username || ""}
          username={username ?? ""}
          access={access}
          isNarrow={isNarrow}
          onLogout={handleLogout}
        />
      </div>
    </header>
  );
}
